import React from 'react'

const Jva_vec = () => {
    return (
        <div className='container'>
            

      <h1 class="h1">Java Vector</h1>
      <p><strong>Vector</strong> is like the <em>dynamic array</em> which can grow or shrink its size. Unlike array, we
            can store n-number of elements in it as there is no size limit. It is a part of Java Collection framework
            since Java 1.2. It is found in the java.util package and implements the
            <em>List</em> interface, so we can use all the methods of List interface here.</p>
      <p>It is recommended to use the Vector class in the thread-safe implementation only. If you don't need to use the
            thread-safe implementation, you should use the ArrayList, the ArrayList will perform better in such case.
      </p>
      <p>The Iterators returned by the Vector class are <em>fail-fast</em>. In case of concurrent modification, it fails
            and throws the ConcurrentModificationException.</p>
      <p>It is similar to the ArrayList, but with two differences-</p>
      <ul class="points">
            <li>Vector is synchronized.</li>
            <li>Java Vector contains many legacy methods that are not the part of a collections framework.</li>
      </ul>
      <h2 class="h3">Java Vector class Declaration</h2>
      <div class="containers">
            <div class="dp-highlighter">
                  
                  <ul start="1" class="dp-j">
                        <li class="alt"><span><span class="keyword">public</span><span>&nbsp;</span><span
                                          class="keyword">class</span><span>&nbsp;Vector&lt;E&gt;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span><span
                                          class="keyword">extends</span><span>&nbsp;Object&lt;E&gt;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span><span
                                          class="keyword">implements</span><span>&nbsp;List&lt;E&gt;,&nbsp;Cloneable,&nbsp;Serializable&nbsp;&nbsp;</span></span>
                        </li>
                  </ul>
            </div>
      </div>
      <h2 class="h3">Java Vector Constructors</h2>
      <p>Vector class supports four types of constructors. These are given below:</p>
      <table class="alt">
            <tbody>
                  <tr>
                        <th>SN</th>
                        <th>Constructor</th>
                        <th>Description</th>
                  </tr>

                  <tr>
                        <td>1)</td>
                        <td>vector()</td>
                        <td>It constructs an empty vector with the default size as 10.</td>
                  </tr>
                  <tr>
                        <td>2)</td>
                        <td>vector(int initialCapacity)</td>
                        <td>It constructs an empty vector with the specified initial capacity and with its capacity
                              increment equal to zero.</td>
                  </tr>
                  <tr>
                        <td>3)</td>
                        <td>vector(int initialCapacity, int capacityIncrement)</td>
                        <td>It constructs an empty vector with the specified initial capacity and capacity increment.
                        </td>
                  </tr>
                  <tr>
                        <td>4)</td>
                        <td>Vector( Collection&lt;? extends E&gt; c)</td>
                        <td>It constructs a vector that contains the elements of a collection c.</td>
                  </tr>
            </tbody>
      </table>
      <h3 class="h3">Java Vector Methods</h3>
      <p>The following are the list of Vector class methods:</p>
      <table class="alt">
            <tbody>
                  <tr>
                        <th>SN</th>
                        <th>Method</th>
                        <th>Description</th>
                  </tr>
                  <tr>
                        <td>1)</td>
                        <td>add()</td>
                        <td>It is used to append the specified element in the given vector.</td>
                  </tr>
                  <tr>
                        <td>2)</td>
                        <td>addAll()</td>
                        <td>It is used to append all of the elements in the specified collection to the end of this
                              Vector.</td>
                  </tr>
                  <tr>
                        <td>3)</td>
                        <td>addElement()</td>
                        <td>It is used to append the specified component to the end of this vector. It increases the
                              vector size by one.</td>
                  </tr>
                  <tr>
                        <td>4)</td>
                        <td>capacity()</td>
                        <td>It is used to get the current capacity of this vector.</td>
                  </tr>
                  <tr>
                        <td>5)</td>
                        <td>clear()</td>
                        <td>It is used to delete all of the elements from this vector.</td>
                  </tr>
                  <tr>
                        <td>6)</td>
                        <td>clone()</td>
                        <td>It returns a clone of this vector.</td>
                  </tr>
                  <tr>
                        <td>7)</td>
                        <td>contains()</td>
                        <td>It returns true if the vector contains the specified element.</td>
                  </tr>
                  <tr>
                        <td>8)</td>
                        <td>containsAll()</td>
                        <td>It returns true if the vector contains all of the elements in the specified collection.</td>
                  </tr>
                  <tr>
                        <td>9)</td>
                        <td>copyInto()</td>
                        <td>It is used to copy the components of the vector into the specified array.</td>
                  </tr>
                  <tr>
                        <td>10)</td>
                        <td>elementAt()</td>
                        <td>It is used to get the component at the specified index.</td>
                  </tr>
                  <tr>
                        <td>11)</td>
                        <td>elements()</td>
                        <td>It returns an enumeration of the components of a vector.</td>
                  </tr>
                  <tr>
                        <td>12)</td>
                        <td>ensureCapacity()</td>
                        <td>It is used to increase the capacity of the vector which is in use, if necessary. It ensures
                              that the vector can hold at least the number of components specified by the minimum
                              capacity argument.</td>
                  </tr>
                  <tr>
                        <td>13)</td>
                        <td>equals()</td>
                        <td>It is used to compare the specified object with the vector for equality.</td>
                  </tr>
                  <tr>
                        <td>14)</td>
                        <td>firstElement()</td>
                        <td>It is used to get the first component of the vector.</td>
                  </tr>
                  <tr>
                        <td>15)</td>
                        <td>forEach()</td>
                        <td>It is used to perform the given action for each element of the Iterable until all elements
                              have been processed or the action throws an exception.</td>
                  </tr>
                  <tr>
                        <td>16)</td>
                        <td>get()</td>
                        <td>It is used to get an element at the specified position in the vector.</td>
                  </tr>
                  <tr>
                        <td>17)</td>
                        <td>hashCode()</td>
                        <td>It is used to get the hash code value of a vector.</td>
                  </tr>
                  <tr>
                        <td>18)</td>
                        <td>indexOf()</td>
                        <td>It is used to get the index of the first occurrence of the specified element in the vector.
                              It returns -1 if the vector does not contain the element.</td>
                  </tr>
                  <tr>
                        <td>19)</td>
                        <td>insertElementAt()</td>
                        <td>It is used to insert the specified object as a component in the given vector at the
                              specified index.</td>
                  </tr>
                  <tr>
                        <td>20)</td>
                        <td>isEmpty()</td>
                        <td>It is used to check if this vector has no components.</td>
                  </tr>
                  <tr>
                        <td>21)</td>
                        <td>iterator()</td>
                        <td>It is used to get an iterator over the elements in the list in proper sequence.</td>
                  </tr>
                  <tr>
                        <td>22)</td>
                        <td>lastElement()</td>
                        <td>It is used to get the last component of the vector.</td>
                  </tr>
                  <tr>
                        <td>23)</td>
                        <td>lastIndexOf()</td>
                        <td>It is used to get the index of the last occurrence of the specified element in the vector.
                              It returns -1 if the vector does not contain the element.</td>
                  </tr>
                  <tr>
                        <td>24)</td>
                        <td>listIterator()</td>
                        <td>It is used to get a list iterator over the elements in the list in proper sequence.</td>
                  </tr>
                  <tr>
                        <td>25)</td>
                        <td>remove()</td>
                        <td>It is used to remove the specified element from the vector. If the vector does not contain
                              the element, it is unchanged.</td>
                  </tr>
                  <tr>
                        <td>26)</td>
                        <td>removeAll()</td>
                        <td>It is used to delete all the elements from the vector that are present in the specified
                              collection.</td>
                  </tr>
                  <tr>
                        <td>27)</td>
                        <td>removeAllElements()</td>
                        <td>It is used to remove all elements from the vector and set the size of the vector to zero.
                        </td>
                  </tr>
                  <tr>
                        <td>28)</td>
                        <td>removeElement()</td>
                        <td>It is used to remove the first (lowest-indexed) occurrence of the argument from the vector.
                        </td>
                  </tr>
                  <tr>
                        <td>29)</td>
                        <td>removeElementAt()</td>
                        <td>It is used to delete the component at the specified index.</td>
                  </tr>
                  <tr>
                        <td>30)</td>
                        <td>removeIf()</td>
                        <td>It is used to remove all of the elements of the collection that satisfy the given predicate.
                        </td>
                  </tr>
                  <tr>
                        <td>31)</td>
                        <td>removeRange()</td>
                        <td>It is used to delete all of the elements from the vector whose index is between fromIndex,
                              inclusive and toIndex, exclusive.</td>
                  </tr>
                  <tr>
                        <td>32)</td>
                        <td>replaceAll()</td>
                        <td>It is used to replace each element of the list with the result of applying the operator to
                              that element.</td>
                  </tr>
                  <tr>
                        <td>33)</td>
                        <td>retainAll()</td>
                        <td>It is used to retain only that element in the vector which is contained in the specified
                              collection.</td>
                  </tr>
                  <tr>
                        <td>34)</td>
                        <td>set()</td>
                        <td>It is used to replace the element at the specified position in the vector with the specified
                              element.</td>
                  </tr>
                  <tr>
                        <td>35)</td>
                        <td>setElementAt()</td>
                        <td>It is used to set the component at the specified index of the vector to the specified
                              object.</td>
                  </tr>
                  <tr>
                        <td>36)</td>
                        <td>setSize()</td>
                        <td>It is used to set the size of the given vector.</td>
                  </tr>
                  <tr>
                        <td>37)</td>
                        <td>size()</td>
                        <td>It is used to get the number of components in the given vector.</td>
                  </tr>
                  <tr>
                        <td>38)</td>
                        <td>sort()</td>
                        <td>It is used to sort the list according to the order induced by the specified Comparator.</td>
                  </tr>
                  <tr>
                        <td>39)</td>
                        <td>spliterator()</td>
                        <td>It is used to create a late-binding and fail-fast Spliterator over the elements in the list.
                        </td>
                  </tr>
                  <tr>
                        <td>40)</td>
                        <td>subList()</td>
                        <td>It is used to get a view of the portion of the list between fromIndex, inclusive, and
                              toIndex, exclusive.</td>
                  </tr>
                  <tr>
                        <td>41)</td>
                        <td>toArray()</td>
                        <td>It is used to get an array containing all of the elements in this vector in correct order.
                        </td>
                  </tr>
                  <tr>
                        <td>42)</td>
                        <td>toString()</td>
                        <td>It is used to get a string representation of the vector.</td>
                  </tr>
                  <tr>
                        <td>43)</td>
                        <td>trimToSize()</td>
                        <td>It is used to trim the capacity of the vector to the vector's current size.</td>
                  </tr>
            </tbody>
      </table>
      <h2 class="h2">Java Vector Example</h2>
      <div class="containers">
            <div class="dp-highlighter">
                  
                  <ul start="1" class="dp-j">
                        <li class="alt"><span><span
                                          class="keyword">import</span><span>&nbsp;java.util.*;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span><span class="keyword">public</span><span>&nbsp;</span><span
                                          class="keyword">class</span><span>&nbsp;VectorExample&nbsp;&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="keyword">public</span><span>&nbsp;</span><span
                                          class="keyword">static</span><span>&nbsp;</span><span
                                          class="keyword">void</span><span>&nbsp;main(String&nbsp;args[])&nbsp;&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Create&nbsp;a&nbsp;vector</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Vector&lt;String&gt;&nbsp;vec&nbsp;=&nbsp;<span
                                          class="keyword">new</span><span>&nbsp;Vector&lt;String&gt;();&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Adding&nbsp;elements&nbsp;using&nbsp;add()&nbsp;method&nbsp;of&nbsp;List</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;vec.add(<span
                                          class="string">"Tiger"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;vec.add(<span
                                          class="string">"Lion"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;vec.add(<span
                                          class="string">"Dog"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;vec.add(<span
                                          class="string">"Elephant"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Adding&nbsp;elements&nbsp;using&nbsp;addElement()&nbsp;method&nbsp;of&nbsp;Vector</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;vec.addElement(<span
                                          class="string">"Rat"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;vec.addElement(<span
                                          class="string">"Cat"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;vec.addElement(<span
                                          class="string">"Deer"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"Elements&nbsp;are:&nbsp;"</span><span>+vec);&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
                        <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
                  </ul>
            </div>
      </div>
 
      <p><strong>Output:</strong></p>
      <div class="output">
            <pre>Elements are: [Tiger, Lion, Dog, Elephant, Rat, Cat, Deer]
      </pre>
      </div>

      <h2 class="h2">Java Vector Example 2</h2>
      <div class="containers">
            <div class="dp-highlighter">
                  
                  <ul start="1" class="dp-j">
                        <li class="alt"><span><span
                                          class="keyword">import</span><span>&nbsp;java.util.*;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span><span class="keyword">public</span><span>&nbsp;</span><span
                                          class="keyword">class</span><span>&nbsp;VectorExample1&nbsp;&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="keyword">public</span><span>&nbsp;</span><span
                                          class="keyword">static</span><span>&nbsp;</span><span
                                          class="keyword">void</span><span>&nbsp;main(String&nbsp;args[])&nbsp;&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Create&nbsp;an&nbsp;empty&nbsp;vector&nbsp;with&nbsp;initial&nbsp;capacity&nbsp;4</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Vector&lt;String&gt;&nbsp;vec&nbsp;=&nbsp;<span
                                          class="keyword">new</span><span>&nbsp;Vector&lt;String&gt;(</span><span
                                          class="number">4</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Adding&nbsp;elements&nbsp;to&nbsp;a&nbsp;vector</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;vec.add(<span
                                          class="string">"Tiger"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;vec.add(<span
                                          class="string">"Lion"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;vec.add(<span
                                          class="string">"Dog"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;vec.add(<span
                                          class="string">"Elephant"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Check&nbsp;size&nbsp;and&nbsp;capacity</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"Size&nbsp;is:&nbsp;"</span><span>+vec.size());&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"Default&nbsp;capacity&nbsp;is:&nbsp;"</span><span>+vec.capacity());&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Display&nbsp;Vector&nbsp;elements</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"Vector&nbsp;element&nbsp;is:&nbsp;"</span><span>+vec);&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;vec.addElement(<span
                                          class="string">"Rat"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;vec.addElement(<span
                                          class="string">"Cat"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;vec.addElement(<span
                                          class="string">"Deer"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Again&nbsp;check&nbsp;size&nbsp;and&nbsp;capacity&nbsp;after&nbsp;two&nbsp;insertions</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"Size&nbsp;after&nbsp;addition:&nbsp;"</span><span>+vec.size());&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"Capacity&nbsp;after&nbsp;addition&nbsp;is:&nbsp;"</span><span>+vec.capacity());&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Display&nbsp;Vector&nbsp;elements&nbsp;again</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"Elements&nbsp;are:&nbsp;"</span><span>+vec);&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Checking&nbsp;if&nbsp;Tiger&nbsp;is&nbsp;present&nbsp;or&nbsp;not&nbsp;in&nbsp;this&nbsp;vector&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="keyword">if</span><span>(vec.contains(</span><span
                                          class="string">"Tiger"</span><span>))&nbsp;&nbsp;</span></span></li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123;&nbsp;&nbsp;</span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"Tiger&nbsp;is&nbsp;present&nbsp;at&nbsp;the&nbsp;index&nbsp;"</span><span>&nbsp;+vec.indexOf(</span><span
                                          class="string">"Tiger"</span><span>));&nbsp;&nbsp;</span></span></li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="keyword">else</span><span>&nbsp;&nbsp;</span></span></li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123;&nbsp;&nbsp;</span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"Tiger&nbsp;is&nbsp;not&nbsp;present&nbsp;in&nbsp;the&nbsp;list."</span><span>);&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Get&nbsp;the&nbsp;first&nbsp;element</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"The&nbsp;first&nbsp;animal&nbsp;of&nbsp;the&nbsp;vector&nbsp;is&nbsp;=&nbsp;"</span><span>+vec.firstElement());&nbsp;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Get&nbsp;the&nbsp;last&nbsp;element</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"The&nbsp;last&nbsp;animal&nbsp;of&nbsp;the&nbsp;vector&nbsp;is&nbsp;=&nbsp;"</span><span>+vec.lastElement());&nbsp;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
                        <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
                  </ul>
            </div>
      </div>
     
      <p><strong>Output:</strong></p>
      <div class="output">
            <pre>Size is: 4 <br />
      Default capacity is: 4 <br />
      Vector element is: [Tiger, Lion, Dog, Elephant] <br />
      Size after addition: 7 <br />
      Capacity after addition is: 8 <br />
      Elements are: [Tiger, Lion, Dog, Elephant, Rat, Cat, Deer] <br />
      Tiger is present at the index 0 <br />
      The first animal of the vector is = Tiger <br />
      The last animal of the vector is = Deer <br />
      </pre>
      </div>
      <h2 class="h2">Java Vector Example 3</h2>
      <div class="containers">
            <div class="dp-highlighter">

                  <ul start="1" class="dp-j">
                        <li class="alt"><span><span
                                          class="keyword">import</span><span>&nbsp;java.util.*;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span><span class="keyword">public</span><span>&nbsp;</span><span
                                          class="keyword">class</span><span>&nbsp;VectorExample2&nbsp;&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="keyword">public</span><span>&nbsp;</span><span
                                          class="keyword">static</span><span>&nbsp;</span><span
                                          class="keyword">void</span><span>&nbsp;main(String&nbsp;args[])&nbsp;&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Create&nbsp;an&nbsp;empty&nbsp;Vector&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Vector&lt;Integer&gt;&nbsp;in&nbsp;=&nbsp;<span
                                          class="keyword">new</span><span>&nbsp;Vector&lt;&gt;();&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Add&nbsp;elements&nbsp;in&nbsp;the&nbsp;vector</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;in.add(<span
                                          class="number">100</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;in.add(<span
                                          class="number">200</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;in.add(<span
                                          class="number">300</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;in.add(<span
                                          class="number">200</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;in.add(<span
                                          class="number">400</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;in.add(<span
                                          class="number">500</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;in.add(<span
                                          class="number">600</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;in.add(<span
                                          class="number">700</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Display&nbsp;the&nbsp;vector&nbsp;elements</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"Values&nbsp;in&nbsp;vector:&nbsp;"</span><span>&nbsp;+in);&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//use&nbsp;remove()&nbsp;method&nbsp;to&nbsp;delete&nbsp;the&nbsp;first&nbsp;occurence&nbsp;of&nbsp;an&nbsp;element</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"Remove&nbsp;first&nbsp;occourence&nbsp;of&nbsp;element&nbsp;200:&nbsp;"</span><span>+in.remove((Integer)</span><span
                                          class="number">200</span><span>));&nbsp;&nbsp;</span></span></li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Display&nbsp;the&nbsp;vector&nbsp;elements&nbsp;afre&nbsp;remove()&nbsp;method</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"Values&nbsp;in&nbsp;vector:&nbsp;"</span><span>&nbsp;+in);&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Remove&nbsp;the&nbsp;element&nbsp;at&nbsp;index&nbsp;4</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"Remove&nbsp;element&nbsp;at&nbsp;index&nbsp;4:&nbsp;"</span><span>&nbsp;+in.remove(</span><span
                                          class="number">4</span><span>));&nbsp;&nbsp;</span></span></li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"New&nbsp;Value&nbsp;list&nbsp;in&nbsp;vector:&nbsp;"</span><span>&nbsp;+in);&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Remove&nbsp;an&nbsp;element</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;in.removeElementAt(<span
                                          class="number">5</span><span>);&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Checking&nbsp;vector&nbsp;and&nbsp;displays&nbsp;the&nbsp;element</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"Vector&nbsp;element&nbsp;after&nbsp;removal:&nbsp;"</span><span>&nbsp;+in);&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Get&nbsp;the&nbsp;hashcode&nbsp;for&nbsp;this&nbsp;vector</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"Hash&nbsp;code&nbsp;of&nbsp;this&nbsp;vector&nbsp;=&nbsp;"</span><span>+in.hashCode());&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Get&nbsp;the&nbsp;element&nbsp;at&nbsp;specified&nbsp;index</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"Element&nbsp;at&nbsp;index&nbsp;1&nbsp;is&nbsp;=&nbsp;"</span><span>+in.get(</span><span
                                          class="number">1</span><span>));&nbsp;&nbsp;</span></span></li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span>
                        </li>
                        <li class="alt"><span>&#125;&nbsp;&nbsp;</span></li>
                  </ul>
            </div>
      </div>
     
      <p><strong>Output:</strong></p>
      <div class="output">
            <pre>Values in vector: [100, 200, 300, 200, 400, 500, 600, 700] <br/>
      Remove first occourence of element 200: true <br/>
      Values in vector: [100, 300, 200, 400, 500, 600, 700] <br/>
      Remove element at index 4: 500 <br/>
      New Value list in vector: [100, 300, 200, 400, 600, 700] <br/>
      Vector element after removal: [100, 300, 200, 400, 600] <br/>
      Hash code of this vector = 130123751 <br/>
      Element at index 1 is = 300 <br/>
      </pre>
      </div>

    

        </div>
    )
}

export default Jva_vec
